// Expose store on window for E2E testing (same pattern as __dialogStore).
let _e2eExposed = false
function exposeForE2E(store: { reset: () => void, markSessionExpired: () => void }): void {
  if (_e2eExposed || !import.meta.client) return
  _e2eExposed = true
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ;(window as any).__authStateStore = {
    reset: () => store.reset(),
    markSessionExpired: () => store.markSessionExpired(),
  }
}

const _useAuthStateStore = defineStore('authState', () => {
  const isSessionExpired = ref(false)

  const markSessionExpired = (): void => {
    isSessionExpired.value = true
  }

  const reset = (): void => {
    isSessionExpired.value = false
  }

  return { isSessionExpired, markSessionExpired, reset }
})

export function useAuthStateStore() {
  const store = _useAuthStateStore()
  exposeForE2E(store)
  return store
}
